// extracted by mini-css-extract-plugin
export default {"container":"_2ISLanRo","warning":"b22DYPwA","oneWorkExperience":"_3h14O1uJ","editModal":"_3gJMGNek"};